module.exports = __webpack_public_path__ + "img/computer-age-3.676f7a76.png";